import { render, staticRenderFns } from "./TicketCard.vue?vue&type=template&id=5ad28ed7&scoped=true&lang=pug"
import script from "./TicketCard.vue?vue&type=script&lang=js"
export * from "./TicketCard.vue?vue&type=script&lang=js"
import style0 from "./TicketCard.vue?vue&type=style&index=0&id=5ad28ed7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad28ed7",
  null
  
)

export default component.exports